
import { FirebaseSingleton } from './firebaseSingleton.js'
import storeVue from "../store/index.js";
import Vue from 'vue';
import Permisos from '../clases/Permisos.js';
import 'izitoast/dist/css/iziToast.css';
import iziToast from 'izitoast'
import _ from 'lodash';
import moment from 'moment';

//

//const dbasesHelper   = database()
export default class PGSHelper {
  constructor(Vue) {
    if (Vue) {
      this.vue = Vue;
    }
  }
  log(data, priority) {

    let useConsole = false;
    let printOnlyPriority = true;
    if (useConsole) {
      if (printOnlyPriority) {
        if (priority) {
          console.log(data);
        }
      } else {
        console.log(data);
      }

    }

  }
  getDireccionCampo() {
    let conf = storeVue.getters["getConfigTenant"]
    if (conf) {
      return conf.Direccion ? conf.Direccion : ""
    }
  }
  getNombreCampo(TENANT) {
    let conf = storeVue.getters["getConfigTenant"]
    if (conf) {
      return conf.Nombre
    }
    if (TENANT == "PCUN") {
      return "CLUBS PUERTO CANCUN SA DE CV"
    } else if (TENANT == "TNTO") {
      return "EL TINTO GOLF COURSE"
    } else if (TENANT == "RIVI") {
      return "RIVIERA CANCUN"
    } else {
      return ""
    }
  }
  forceReactivity(param) {

  }
  getTenantConfig(store) {
    store.getters.getConfigTenant()
  }
  getDate(date = null, format = null) {
    let f = (date) ? ((format) ? moment(date, format) : moment(date)) : moment();
    return f;
  }
  checkVirtualKeyBoard(entorno) {
    let actualOption = localStorage.getItem("useVirtualKeyboard");
    actualOption = (actualOption == 'true')
    if (actualOption) {

      entorno.$uvVirtualKeyboard.init(() => {

        //this.$forceUpdate()
      });

    }
  }
  getIvaByFamilia(Familias, idFamilia) {
    let exist = this.getById(Familias, "id", idFamilia)
    if (exist) {
      if (exist.Giva) {
        if (typeof exist.Giva === "string" || typeof exist.Giva === "number") {
          return Number(exist.Giva)
        } else {
          return 16
        }
      } else {
        return 0
      }
    } else {
      return 0
    }

  }
  test() {
    alert('helper funcionando');
  }
  rand() {
    return Math.random().toString(36).substr(2);
  }
  token() {
    return this.rand() + this.rand();
  }
  indexBy(data, prop) {
    let itemIndex = _.orderBy(data, [prop]);
    return itemIndex;
  }
  searchIndex(data, prop, value) {
    if (!value) {
      return false
    }
    let itemIndex = _.sortedIndexBy(data, { [prop]: value }, (o) => {
      return o[prop]
    });
    if (data[itemIndex]?.[prop] === value) {
      data[itemIndex].idx = itemIndex;
      return data[itemIndex];
    }
    return false;
  }
  getById(data, prop, code) {
    let data_fileter = {};
    data_fileter[prop] = code;
    let itemIndex = _.findIndex(data, data_fileter);
    if (itemIndex >= 0) {
      data[itemIndex].idx = itemIndex;
      return data[itemIndex];
    }

    return false;
  }
  /**
   * Crea un Map indexado por una propiedad para lookups O(1).
   * Usar en lugar de getById() dentro de loops.
   * @param {Array} data - Array de objetos
   * @param {string} prop - Propiedad clave (ej: "id", "Id")
   * @returns {Map} Map indexado
   */
  createIndex(data, prop) {
    const map = new Map();
    if (Array.isArray(data)) {
      data.forEach(item => {
        if (item && item[prop] !== undefined) {
          map.set(item[prop], item);
        }
      });
    }
    return map;
  }
  filterBy(data, prop, value, propIsArray = false) {
    let dataFiltered = []
    if (!propIsArray) {
      dataFiltered = data.filter((item) => item[prop] == value)
    } else {
      dataFiltered = data.filter((item) => item[prop] && item[prop].includes(value))
    }

    return dataFiltered
  }

  writeConfigFile(idCaja, modulo) {
    var obj = {
      caja_id: idCaja,
      modulo: modulo,
    };
    var json = JSON.stringify(obj);
    var fs = require('fs');
    fs.writeFile('configCaja.json', json, 'utf8', () => { });
  }
  getPDVDepartamento(vue) {
    let config = this.readConfig();
    let departamento = this.getById(vue.$store.getters.getPDVDepartamentos, 'id', config.modulo);
    return departamento;
  }
  restaurarCaja() {
    var obj = {

    };
    var json = JSON.stringify(obj);
    var fs = require('fs');
    fs.writeFile('configCaja.json', json, 'utf8', () => { });
  }
  readConfig() {
    var fs = require('fs');
    try {
      const json = fs.readFileSync('configCaja.json', 'utf8');
      let obj = JSON.parse(json);

      return obj;

    } catch (err) {
      var obj = {

      };
      var json = JSON.stringify(obj);

      fs.writeFile('configCaja.json', json, 'utf8', () => { });
      return obj

    }



  }
  roundDecimals(value) {
    let valFloat = parseFloat(value).toFixed(2);
    return Number(valFloat)
  }
  formatNumber(num) {
    let rounded = this.roundDecimals(Number(num))
    return rounded.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
  roundNumber(num) {
    let rounded = this.roundDecimals(Number(num))
    return rounded;
  }
  checkLimitCaja(limit, vue, confirmCallback) {

    let caja = JSON.parse(localStorage.getItem('caja'));
    if (!caja) {
      caja = { open: false };
    } else {

      if ((caja.totalVentas) - caja.totalRetiros > limit) {

        vue.$swal({
          icon: 'warning',
          title: 'Se alcanzo el limite de efectivo permitido en la caja',
          text: '',
          confirmButtonText: 'Realizar un retiro',
          cancelButtonText: "Continuar sin retirar",
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            confirmCallback();
          }
        });
        return false;
      }
    }
  }

  onlyNumber($event, value, allowNegative = false) {
    try {
      if (value === null || value === undefined) {
        value = "";
      }
      value = value.toString();
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

      // minus sign only at the start
      if (allowNegative && keyCode === 45) {
        const input = $event.target;
        if (value.indexOf('-') !== -1 || (input && input.selectionStart > 0)) {
          $event.preventDefault();
        }
        return;
      }

      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || value.indexOf('.') != -1)) { // 46 is dot
        $event.preventDefault();
      }
      if (value != 0 && value.indexOf(".") > -1) {
        const parts = value.split('.');
        if (parts[1] && parts[1].length >= 20) {
          $event.preventDefault();
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
  getDayName(numberDay, mode) {
    let days = ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"];
    let daysCompletName = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"];
    if (mode == "Simple") {
      return days[numberDay];
    } else {
      return daysCompletName[numberDay];
    }
  }
  uiConfig() {
    let conf = storeVue.getters["getConfigTenant"]
    return {
      mainColor: (conf.Color) ? conf.Color : 'light-blue darken-4',
      appName: 'ParGolf'
    }
  }
  ArrayObjectToArray(object) {
    let arrayObject = Object.entries(object);
    let parseArray = [];
    arrayObject.forEach(function (element) {
      parseArray.push({ id: element[0], ...element[1] });
    });
    return parseArray;
  }
  invertColor(hex, bw = true) {
    try {
      if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
      }
      // convert 3-digit hex to 6-digits.
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
      if (bw) {
        // https://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
          ? '#000000'
          : '#FFFFFF';
      }
      // invert color components
      r = (255 - r).toString(16);
      g = (255 - g).toString(16);
      b = (255 - b).toString(16);
      // pad each with zeros and return
      return "#" + this.padZero(r) + this.padZero(g) + this.padZero(b);
    } catch (e) {
      return '#FFFFFF';
    }
  }

  async writeLogAdminElevationPDV(logData) {
    try {
      //let config = this.getPDVDepartamento(this);

      const user = await storeVue.getters.getFirebaseApp.auth
        .getCurrentUserFirstTime;
      console.log(user)
      storeVue.getters.getFirebaseApp.fba.call("PDV-Cajas-escribirRegistroCaja", {
        /** DEPARTAMENTO */
        'dp': { 'id': "ADMINISTRADOR WEB", 'nm': "ADMINISTRADOR WEB" },
        /** TURNO */
        'tn': "NA",
        /** CAJA */
        'cj': { 'id': "NA", 'nm': "NA" },
        /** CAJERO */
        'cr': { 'id': "NA", 'nm': "NA" },
        /** CLIENTE (al=alias,gp=grupo) */
        'cl': { 'id': "NA", 'nm': "NA", al: "NA", gp: "NA" },
        /** EVENTO */
        'ev': logData.Evento,
        /** MENSAJE */
        'ms': logData.Mensaje,
        /** DATOS ADICIONALES */
        'dt': {
          rs: true,
          /** Admin que aprobo */
          ad: { id: user.tokenResult.claims.user_id, nm: user.displayName },
          /** Operacion a realizar */
          op: {
            /** CODIGO DE OPERACION */
            cd: logData.Evento,
            /** REFERENCIA AL DOCUMENTO OBJETIVO */
            /*.   {id ,tp ,al}  */
            rf: logData.reference,
          }
        }
      })
    } catch (e) {
      console.log("error");

    }

  }
  async writeLog(logData) {
    try {
      //let config = this.getPDVDepartamento(this);

      const user = await storeVue.getters.getFirebaseApp.auth
        .getCurrentUserFirstTime;
      console.log(user)
      storeVue.getters.getFirebaseApp.fba.call("GBL-Registros-escribirRegistro", {
        or: {
          tp: "ADMINISTRADOR_WEB",
          id: "NA",
          nm: "ADMINISTRADOR WEB",
        },
        ac: {
          tp: "USER_ADMIN",
          id: user.tokenResult.claims.user_id,
          nm: user.displayName
        },
        cx: {
          /** Departamento */
          dp: { 'id': "ADMINISTRADOR WEB", 'nm': "ADMINISTRADOR WEB" },
          /** Turno */
          tn: "NA",
          /** CLIENTE */
          cl: { 'id': "NA", 'nm': "NA", al: "NA", gp: "NA" },
        },
        /** EVENTO */
        'ev': logData.Evento,
        /** MENSAJE */
        'ms': logData.Mensaje,
        /** DATOS ADICIONALES */
        'dt': {
          rs: true,
          /** Admin que aprobo */
          ad: { id: user.tokenResult.claims.user_id, nm: user.displayName },
          /** Operacion a realizar */
          op: {
            /** CODIGO DE OPERACION */
            cd: logData.Evento,
            /** REFERENCIA AL DOCUMENTO OBJETIVO */
            /*.   {id ,tp ,al}  */
            rf: logData.reference,
          },
          data: logData.data
        }
      })
    } catch (e) {
      console.log("error");

    }

  }
  cloneObj(obj) {
    //clona el elemento sin la referencia de objeto
    return JSON.parse(JSON.stringify(obj))
  }
  verifyPermissions(permission, departamento, code) {
    /*const userPermissions = new Permisos("Admin");
    let permissionData = userPermissions.MergePermissions(userPermissions.roleBlock,userPermissions.patch);*/
    //return userPermissions.validatePermission(permissionData,permission,departamento,code);
    return true;
  }
  catchError(e, config = {}) {
    if (config.action == 'log') {
      console.log(e);
    } else if (config.action == 'alert') {
      iziToast.error(
        {
          title: e.name,
          message: e.message,
        }
      );
    }
  }
  async getTicketCss() {
    /*let css = await fetch('/ticket.css')
    let text = await css.text();*/
    let text = `

    @page {
      size: auto;   /* auto is the initial value */
      height: auto !important;
      margin: .5cm;
      page-break-after:always;
    }
    
    @media only print {
      * { overflow: visible !important; } 
      .container-ticket {
        width: auto;
        height: auto;
        overflow: visible;
        page-break-after:always;
      }
    }
      .fontSize{
        font-size: 16px;
      }
      .container-ticket {
        line-height: initial;
        font-family: "Roboto", sans-serif;
        color: #1f1f1f;
        font-size: 15px;
      }
      .container-ticket2 {
        font-family: "Roboto", sans-serif;
        color: #1f1f1f;
        font-size: 16px;
      }
      .bold {
        font-weight: bold;
      }
      .titleTicket{
        font-size: 16px;
        text-align: center;
      }
      .titleTicket p{
        margin :0 !important;
      }
      .center {
        text-align: center;
      }
      .receipt {
        width: 300px;
    
      }
      .main-title {
        text-align: center;
        padding: 10px;
        font-size: 18px;
      }
      .barcode {
        font-family: "Libre Barcode 128", cursive;
        font-size: 42px;
        text-align: center;
      }
      .address {
        text-align: center;
        margin-bottom: 10px;
      }
      .maintext{
    
      }
      .transactionDetails {
    
        font-size:16px;
    
        margin: 0 10px 10px;
      }
      .transactionDetails .detail {
        text-transform: uppercase;
        font-size:16px;
      }
      .detailTicket{
        margin:0;
        font-size:14px;
      }
      .centerItem {
        display: -webkit-box; /* wkhtmltopdf uses this one */
        display: flex;
        justify-content: center;
        -webkit-box-pack: center; /* wkhtmltopdf uses this one */
        margin-bottom: 8px;
      }
    
      .p{
          margin:0;
      }
      .survey {
        text-align: center;
        margin-bottom: 12px;
      }
      .survey .surveyID {
        font-size: 16px;
      }
      .paymentDetails {
        font-size: 14px;
        display: -webkit-box; /* wkhtmltopdf uses this one */
        display: flex;
        justify-content: space-between;
        -webkit-box-pack: justify;
      }
      .creditDetails {
        margin: 10px 20px;
        /*width: 230px;*/
        font-size: 16px;
        text-transform: uppercase;
      }
      .receiptBarcode {
        margin: 10px 0;
        text-align: center;
      }
      .returnPolicy {
        margin: 10px 20px;
        display: -webkit-box; /* wkhtmltopdf uses this one */
        display: flex;
        justify-content: space-between;
        -webkit-box-pack: justify;
      }
      .pagos{
        font-size: 15px !important;
      }
    
      .coupons {
        margin-top: 20px;
      }
      .tripSummary {
        margin: auto;
        /*width: 255px;*/
      }
      .tripSummary .item {
        display: -webkit-box; /* wkhtmltopdf uses this one */
        display: flex;
        justify-content: space-between;
        -webkit-box-pack: justify;
        margin: auto;
      }
      .feedback {
        margin: 20px auto;
      }
      .feedback h3.clickBait {
        font-size: 30px;
        font-weight: bold;
        text-align: center;
        margin: 10px 0;
      }
      .feedback h4.web {
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        margin: 10px 0;
      }
      .feedback .break {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        margin: 10px 0;
      }
      .couponContainer {
        border-top: 1px dashed #1f1f1f;
        margin-bottom: 20px;
      }
      .couponContainer .discount {
        font-size: 35px;
        text-align: center;
        margin-bottom: 10px;
      }
      .couponContainer .discountDetails {
        font-size: 16px;
        text-align: center;
        margin-bottom: 15px;
      }
      .couponContainer .barcode {
        margin: 10px 0 0;
      }
      .couponContainer .legal {
        font-size: 12px;
        margin-bottom: 12px;
      }
      .couponContainer .barcodeID {
        margin-bottom: 8px;
      }
      .couponContainer .expiration {
        display: -webkit-box; /* wkhtmltopdf uses this one */
        display: flex;
        justify-content: space-between;
        -webkit-box-pack: justify;
        margin: 10px;
      }
      .couponContainer .couponBottom {
        font-size: 13px;
        text-align: center;
      }`;
    return text;
  }
  getHtmlFromComponent(vue, component, props = {}) {
    try {
      let ComponentClass = Vue.extend(component)
      let instance = new ComponentClass({ propsData: props })
      instance.$mount()
      let html = instance.$el.innerHTML
      instance.$destroy();
      return html
    } catch (e) {
      console.log(e)
    }
  }
  configuracionDepartamento(store, depto) {
    let departamento = this.getById(store.getters.getPDVDepartamentos, 'id', depto);
    return departamento;
  }
  generateQrConfig(text, content, fileName) {
    return {
      config: {
        styles: {
          width: 300,
          height: 300,
          colorDark: "#000000",
          colorLight: "#FFFFFF",
        },
        qr: {
          text: text,
          level: "H",
        },
        text: {
          content: content,
          font: "20px roboto",
          color: "#000000",
          margin: -15,
        },
      },
      descargar: {
        nombreArchivo: fileName,
        extension: "jpeg",
      }
    };
  }
  printTicket(vue, html, defaultPreviousPrinter = null, printerSelected = null) {
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.print();
    }

  }


}